import { useState } from 'react';
import MapView from './MapView';

// Example data in different formats
const exampleData = {
  simple: {
    center: [51.505, -0.09],
    zoom: 13,
    markers: [
      { position: [51.505, -0.09], text: "London", color: "red" },
      { position: [51.51, -0.1], text: "Marker 2", color: "green" },
      { position: [51.51, -0.12], text: "Marker 3", color: "blue" }
    ]
  },
  
  latLon: {
    center: { lat: 40.7128, lon: -74.006 },
    zoom: 12,
    markers: [
      { lat: 40.7128, lon: -74.006, name: "New York", color: "red" },
      { lat: 40.7282, lon: -73.994, name: "Empire State", color: "blue" },
      { lat: 40.7484, lon: -73.9857, name: "Times Square", color: "green" }
    ]
  },
  
  arrayFormat: [
    [34.052235, -118.243683, "Los Angeles"],
    [37.7749, -122.4194, "San Francisco"],
    [32.7157, -117.1611, "San Diego"]
  ],
  
  manyMarkers: {
    center: [37.7749, -122.4194],
    zoom: 10,
    markers: Array(100).fill(0).map((_, i) => ({
      lat: 37.7749 + (Math.random() - 0.5) * 0.5,
      lon: -122.4194 + (Math.random() - 0.5) * 0.5,
      name: `Random Point ${i+1}`,
      color: ["red", "blue", "green", "orange", "purple"][Math.floor(Math.random() * 5)]
    }))
  },
  
  apiFormat: {
    center: [37.7749, -122.4194],
    zoom: 12,
    markers: [
      { lat: 37.7749, lon: -122.4194, name: "San Francisco", color: "red" },
      { lat: 37.7833, lon: -122.4167, name: "Downtown SF", color: "blue" },
      { lat: 37.8083, lon: -122.4156, name: "Golden Gate Bridge", color: "green" }
    ]
  },
  
  interpretationFormat: (() => {
    // Create sample data that matches the API response format
    const rows = [
      { "Location Name": "San Francisco", "Latitude": "37.7749", "Longitude": "-122.4194" },
      { "Location Name": "New York", "Latitude": "40.7128", "Longitude": "-74.0060" },
      { "Location Name": "Chicago", "Latitude": "41.8781", "Longitude": "-87.6298" }
    ];
    
    // This is what our getChartData function expects to process
    return {
      markers: rows.map(item => ({
        lat: parseFloat(item["Latitude"]),
        lon: parseFloat(item["Longitude"]),
        name: item["Location Name"] || 'Location',
        color: 'blue'
      })),
      center: [37.7749, -122.4194],
      zoom: 12
    };
  })()
};

const MapExample = () => {
  const [selectedExample, setSelectedExample] = useState('simple');
  
  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Map Example</h2>
      
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Select Example Data Format:
        </label>
        <div className="flex flex-wrap space-x-4">
          <button
            onClick={() => setSelectedExample('simple')}
            className={`px-3 py-1 rounded mb-2 ${
              selectedExample === 'simple' 
                ? 'bg-blue-500 text-white' 
                : 'bg-gray-200 text-gray-800'
            }`}
          >
            Simple
          </button>
          <button
            onClick={() => setSelectedExample('latLon')}
            className={`px-3 py-1 rounded mb-2 ${
              selectedExample === 'latLon' 
                ? 'bg-blue-500 text-white' 
                : 'bg-gray-200 text-gray-800'
            }`}
          >
            Lat/Lon Format
          </button>
          <button
            onClick={() => setSelectedExample('arrayFormat')}
            className={`px-3 py-1 rounded mb-2 ${
              selectedExample === 'arrayFormat' 
                ? 'bg-blue-500 text-white' 
                : 'bg-gray-200 text-gray-800'
            }`}
          >
            Array Format
          </button>
          <button
            onClick={() => setSelectedExample('manyMarkers')}
            className={`px-3 py-1 rounded mb-2 ${
              selectedExample === 'manyMarkers' 
                ? 'bg-blue-500 text-white' 
                : 'bg-gray-200 text-gray-800'
            }`}
          >
            Many Markers (100)
          </button>
          <button
            onClick={() => setSelectedExample('apiFormat')}
            className={`px-3 py-1 rounded mb-2 ${
              selectedExample === 'apiFormat' 
                ? 'bg-blue-500 text-white' 
                : 'bg-gray-200 text-gray-800'
            }`}
          >
            API Format
          </button>
          <button
            onClick={() => setSelectedExample('interpretationFormat')}
            className={`px-3 py-1 rounded mb-2 ${
              selectedExample === 'interpretationFormat' 
                ? 'bg-blue-500 text-white' 
                : 'bg-gray-200 text-gray-800'
            }`}
          >
            Interpretation Format
          </button>
        </div>
      </div>
      
      <div className="mb-4">
        <MapView data={exampleData[selectedExample]} />
      </div>
      
      <div className="mt-4 bg-gray-100 p-4 rounded-lg">
        <h3 className="text-lg font-semibold mb-2">Current Data Format:</h3>
        <pre className="text-xs overflow-auto max-h-60">
          {JSON.stringify(exampleData[selectedExample], null, 2)}
        </pre>
      </div>
    </div>
  );
};

export default MapExample; 